module.exports = __webpack_public_path__ + "static/media/logo.3c81ec3c.svg";